import Main from './views/ut-card';
export default Main;
